import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Transparent_Logo.png";
import LogoutButton from "./LogoutButton";

interface Props {
  title: string;
}

const ToolHeader = ({ title }: Props) => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" sx={{ backgroundColor: "#B91C1C" }}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
          <Box
            component="img"
            src={logo}
            alt="3S Logo"
            sx={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </Box>

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography variant="h6" sx={{ color: "white" }}>
            {title}
          </Typography>
        </Box>

        <Box sx={{ flex: 1, textAlign: "right" }}>
          <LogoutButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default ToolHeader;
